import type { Product } from "@/types/product";
import type { ThreeDAsset } from "@/types/threeDAsset";
import { defineStore } from "pinia";

interface ProductState {
  products: Product[];
  selectedProduct: Product | null;
  threeDAssets: ThreeDAsset[];
  selected3DAsset: ThreeDAsset | null;
}

export const useProductStore = defineStore("product", {
  state: (): ProductState => ({
    products: [],
    selectedProduct: null,
    threeDAssets: [],
    selected3DAsset: null,
  }),

  actions: {
    setProducts(products: Product[]) {
      this.products = products;
      this.threeDAssets = products.flatMap(
        (product) => product.threeDAssets
      );
    
      if (
        this.selected3DAsset &&
        !this.threeDAssets.some(
          a => a.url === this.selected3DAsset?.url
        )
      ) {
        this.selected3DAsset = null;
      }
    },

    setSelected3DAsset(asset: ThreeDAsset | null) {
      this.selected3DAsset = asset;
    },

    add3DAsset(asset: ThreeDAsset) {
      this.threeDAssets.push(asset);
      if (this.selectedProduct) {
        this.selectedProduct.threeDAssets.push(asset);
      }
    },

    clearProducts() {
      this.products = [];
      this.selectedProduct = null;
      this.selected3DAsset = null;
    },
  },
});
